// While the backend restarts, the dev proxy answers 504 (nginx 502) to every
// request. The requests a page makes once at load and never again (the
// session, the organizations, the tenant config) retry those, backing off for
// about 15 s: 0.5, 1, 2, 4 then 8 s, so at most 6 requests each. Only gateway
// errors, and only GETs.
export const RESTART_RETRY = { type: "exponential", attempts: 5, baseDelay: 500, maxDelay: 8000 } as const;

export const isGatewayError = (status: number) => status === 502 || status === 503 || status === 504;

export async function fetchThroughRestart(url: string) {
  for (let attempt = 0; ; attempt++) {
    const response = await fetch(url);
    if (!isGatewayError(response.status) || attempt === RESTART_RETRY.attempts) return response;
    await new Promise((resolve) => setTimeout(resolve, RESTART_RETRY.baseDelay * 2 ** attempt));
  }
}
